import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import 'element-ui/lib/theme-chalk/index.css'
// 重制dom 默认元素
import '@/assets/style/common.css'
import '@/assets/style/reset.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'lib-flexible'
import 'swiper/css/swiper.min.css' // 根据实际路径和文件修改
// import 'swiper/dist/css/swiper.css';

import './assets/style/style.scss'
import API from './api/api'
import animated from 'animate.css'
import './assets/js/constant.js'
import moment from "moment"

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)
Vue.use(animated)
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.use(API)
Vue.prototype.$moment = moment;

// alert(
// moment(new Date(1608645679000).getTime()).format('YYYY-MM-DD h:mm'))


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')